export var setHeaders = function (customCacheTTL, isBrowser, customRouting, isStagingRequest) {
    if (isStagingRequest === void 0) { isStagingRequest = false; }
    var headers = {};
    if (customCacheTTL && !isBrowser) {
        headers['x-wix-site-assets-custom-cache'] = customCacheTTL;
    }
    if (customRouting && !isBrowser) {
        var upstream = isStagingRequest ? 'site-assets-staging' : 'site-assets';
        headers["x-wix-route-".concat(upstream)] = customRouting;
    }
    return headers;
};
